import axios from 'axios'
import { cloneDeep } from 'lodash'

const CancelToken = axios.CancelToken;
let cancel;

export default (baseUrl, filters, sorts, per_page, page, searchTerm, searchType, searchByMoveActive = false, radius = undefined, mapCenter = undefined) => {
  if (cancel != undefined) {
    cancel()
  }
  const searchUrl = `${baseUrl}/venues/search`

  const cuisines = []

  let newFilters = cloneDeep(filters)
  newFilters.forEach( ( newFilter ) => {
    if ( newFilter['filters'] ) {
      newFilter['filters'].forEach( nestedFilter => {
        if ( nestedFilter['field'] === 'awards.name' ) {
          if ( nestedFilter['value'].includes('Michelin Green Star') ) {
            nestedFilter['value'] = 'Michelin Green Star'
          } else if ( nestedFilter['value'].includes('Michelin') ) {
            nestedFilter['value'] = 'Michelin'
          } else if ( nestedFilter['value'].includes('AA') ) {
            nestedFilter['value'] = 'AA'
          }
        }
        if ( nestedFilter['field'] === 'awards.pivot.score' ) {
          nestedFilter['value'] = parseInt( nestedFilter['value'] )
        }
      })
    }
    if ( newFilter['field'] ) {
      if ( newFilter['field'] === 'cuisines.description' ) {
        cuisines.push(newFilter)
      }
    }
  })

  if ( cuisines.length ) {
    newFilters.push({
      filters: cuisines,
      group_mode: 'OR',
    })

    newFilters = newFilters.filter( x => x.field !== 'cuisines.description' )
  }

  const hasClubOffersOnly = newFilters.some( x => x.field === 'limited_edition_bool' )
  if ( hasClubOffersOnly ) {
    newFilters = newFilters.filter( x => x.field !== 'limited_edition_bool' )
    newFilters.push({
      filters: [
        { 'field': 'limited_edition_bool', 'condition': 'eq', 'value': 1 },
        { 'field': 'club_access', 'condition': 'eq', 'value': 1 },
      ],
      group_mode: 'OR',
    })
  }


  const data = {
    filters: newFilters,
    sorts,
    page,
    per_page,
  }

  if ( searchTerm ) {
    data['text'] = searchTerm
  }
  if ( searchType ) {
    data['type'] = searchType
  }

  if (searchByMoveActive && mapCenter) {
    data['per_page'] = 99999
    data['page']=1
    data['radius'] = radius * 1.5 || 0

    data['text'] = mapCenter
    data['type'] = 'location'
  }

  return axios({
    method: 'POST',
    url: searchUrl,
    cancelToken: new CancelToken(c => cancel = c),
    data,
  })
}
